module.exports = __webpack_public_path__ + "static/media/001.1a36034a.webp";